import { render, staticRenderFns } from "./StartupsModal.vue?vue&type=template&id=c77d06be&scoped=true&"
import script from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupsModal.vue?vue&type=style&index=0&id=c77d06be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77d06be",
  null
  
)

export default component.exports